import { create } from 'zustand';

interface LearnerDashboardStore {
  selectedOverviewTabId: string;
  setSelectedOverviewTabId: (tabId: string) => void;
}

export const useLearnerDashboardStore = create<LearnerDashboardStore>((set) => ({
  selectedOverviewTabId: 'bookmarks',
  setSelectedOverviewTabId: (tabId: string) => set({ selectedOverviewTabId: tabId }),
}));
